import React from 'react';
import Card from './Card';

import { RENT, COMMERCIALS } from '../../../consts';

class RentCommercials extends React.Component {
  static fetchData (dispatch, location) {
    return Card.fetchData(dispatch, location);
  }

  render () {
    return (
      <Card
        dealType={RentCommercials.dealType}
        realtyType={RentCommercials.realtyType}
        defaultSeoTitle='Аренда коммерческой'
        defaultSeoDescription=''
        {...this.props}
      />
    );
  }
}
RentCommercials.dealType = RENT;
RentCommercials.realtyType = COMMERCIALS;

export default RentCommercials;



// WEBPACK FOOTER //
// ./src/app/CardAnnouncement/components/RentCommercials.js